import React, { useState } from 'react';
import { useTranslation } from "react-i18next";
import {
    Box,
    Button
} from "@mui/material";
import { MapItTextField } from "src/components/common";
import { get } from 'lodash';
import * as Joi from "joi";
import runJoiValidate from "src/_utils/runJoiValidate";
import { pick } from 'lodash';
import { MapItLocalizedNumberTextField } from "src/components/common";

const AddOrderItem = ({ handleAdd, ...rest }) => {

    const { t } = useTranslation();
    const [state, setState] = useState({});
    const schema = Joi.object({
        description: Joi.string()
            .required()
            .label(t("Description"))
            .messages({
                'any.required': `{#label} ${t("validationErrors.isRequired")}`,
                'string.empty': `{#label} ${t("validationErrors.isEmpty")}`,
            }),
        count: Joi.number()
            .required()
            .min(1)
            .label(t("Count"))
            .messages({
                'any.required': `{#label} ${t("validationErrors.isRequired")}`,
                'string.empty': `{#label} ${t("validationErrors.isEmpty")}`,
                'number.base': `{#label} ${t("validationErrors.isNumber")}`,
            }),
    });

const handleChange = (event) => {
    setState({
        ...state,
        [event.target.name]: event.target.value
    });
};

const onAddClicked = _ => {
    const item = pick(state, "count", "description")
    // Validate
    const validationErrors = runJoiValidate(schema, item);
    setState({
        ...state,
        validationErrors
    });
    console.log(state)
    if (validationErrors) return;
    handleAdd(item)
    setState({});
}

return (
    <Box {...rest} sx={{ display: "flex", width: '100%', alignItems: 'flex-start' }}>
        <Box mb={1} sx={{ display: "flex", flexDirection: 'column', flex: 1 }}>
            <MapItTextField
                label={t("Description")}
                name="description"
                value={get(state, "description") || ""}
                handleChange={handleChange}
                error={get(state, "validationErrors.description")}
                size="small"
            />
        </Box>
        <Box mx={1} mb={1} sx={{ display: "flex", flexDirection: 'column', flex: {xs: 0.5, sm: 0.3} }}>
            <MapItLocalizedNumberTextField
                onKeyDown={(event) => {
                    if (event.key === "Enter") {
                        onAddClicked()
                    }
                }}
                label={t("Count")}
                name="count"
                value={get(state, "count") || ""}
                handleChange={handleChange}
                error={get(state, "validationErrors.count")}
                max={99999}
                min={1}
            />
        </Box>
        <Box mb={1} sx={{ display: "flex", flexDirection: 'column', justifyContent: "center" }}>
            <Button
                variant="contained"
                sx={{
                    textTransform: "none",
                }}
                onClick={onAddClicked}
            >
                {t("Add")}
            </Button>
        </Box>
    </Box>
)
}

export default AddOrderItem;